// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.4baa15ff6',
  revision: '4baa15ff6',
  branch: 'develop',
  date: 'Tue, 23 Jun 2026 16:02:57 GMT'
};